import {Pipe, PipeTransform} from '@angular/core';
import {Geometry} from '@turf/helpers';

@Pipe({
    name: 'convertGeometry'
})
export class ConvertGeometryPipe implements PipeTransform {

    transform(geo: Geometry, ...args: unknown[]): { lat: number, lng: number }[] {
        return geo.coordinates.map(c => {
            return {lat: c[1], lng: c[0]}
        });
    }

}
